import { isEmptyString, isNotSet } from "@/tools/format.checker";
import moment from "moment";

// noinspection RegExpSimplifiable
const emailReg =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const required = (value: string) =>
  isNotSet(value) || isEmptyString(value.trim()) ? "此欄位為必填" : undefined;

export const maxLength = (max: number) => (value: string) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = (min: number) => (value: string) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const fixedLength = (length: number) => (value: string) =>
  !value || value.length !== length ? `請輸入 ${length} 碼` : undefined;

export const validRequiredAndPhone = (value: string) => {
  if (!value || valueLengthInRange(9, 10)(value)) return "請輸入正確的電話";
  return undefined;
};

export const validRequiredAndSms = (value: string) => {
  if (!value || value.length !== 6) return "請輸入正確的驗證碼";
  return undefined;
};

export const valueLengthInRange =
  (min: number, max: number) => (value: string) => {
    return value.length >= min && value.length <= max
      ? undefined
      : `要求${min} ~ ${max}字.`;
  };

export const valueInRange = (min: number, max: number) => (value: string) => {
  return parseInt(value, 10) >= min && parseInt(value, 10) <= max
    ? undefined
    : `正確值應為${min} ~ ${max}.`;
};

export const emailValidator = (value: string) =>
  value && emailReg.test(value) ? undefined : "請輸入正確的電子郵件";

export const dateValidator = (value: string) =>
  moment(value, "YYYY/MM/DD", true).isValid()
    ? undefined
    : "正確日期格式為YYYY / MM / DD";

export const vatNumberValidator = (value: string) => {
  return /^\d{8}$/.test(value) ? undefined : "請輸入正確的統一編號";
};

export const digitValidator = (value: string) => {
  return /^\d+$/.test(value) ? undefined : "請輸入數字";
};
